import React, { useContext, useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Header } from "./Header";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Form, Button, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Eye, EyeOff } from "lucide-react";
import "../../src/assets/AdminCss/register.css";
import ToastMessage from "./ToastMessage";
import { AuthContext } from "../context/Authcontext";
import { Link } from "react-router-dom";
import LoginReg from "./LoginReg";
import toast from "react-hot-toast";

const handleFooterLink = () => {
  toast.success("Coming Soon!", {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const RegisterForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const { Register } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    username: "",
    phoneNumber: "",
    cpassword: "",
    pwd: "",
    imOver18: false,
    iAcceptAll: false,
  });

  // Handle window resize to detect mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(true);

  const handleclearRegisterForm = () => {
    setFormData({
      username: "",
      phoneNumber: "",
      cpassword: "",
      pwd: "",
      imOver18: false,
      iAcceptAll: false,
    });
  };

  // Handle form submission
  const submitregister = (e) => {
    e.preventDefault();
    if (
      !formData.username ||
      !formData.phoneNumber ||
      !formData.cpassword ||
      !formData.pwd ||
      !formData.imOver18 ||
      !formData.iAcceptAll
    ) {
      ToastMessage(0, "All fields are required!");
      return;
    }
    let { imOver18, iAcceptAll, ...data } = formData;
    
    Register(data, function (res) {
      if (res.status) {
        ToastMessage(1, res.message);
        handleclearRegisterForm();
        setactive(true);
        setregactive(false);
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  // Apply different container classes based on device
  const containerClass = isMobile 
    ? "mobile-full-height-container" 
    : "regular-container";

  return (
    <>
    {<LoginReg setactive={active} setregactive={regactive} />}
      <div className={containerClass} style={{ backgroundColor: "#fff" , height:"100%" , margin:"0" , padding:"0", overflowX:"hidden" }}>
        <div className="head-container head-container2" style={{ backgroundColor: "#fff" }}>
          <div className="body-container body-container2">
            <div
              className="rightbar rightbar2"
              style={{
                width: "100%",
                transition: "width 0.3s ease-in-out",
              }}
            >
              <div className="header-container">
                <Header />
              </div>
              
              <div className="devasss"></div>

              <Container
                className={`py-4 main-conatiners ${isMobile ? 'p-0' : ''}`}
                style={{ backgroundColor: "#000" }}
              >
                <div className="form-container">
                  {/* Logo */}
                  <div className="text-center mb-3 logo-container text-centers">
                    <img
                      src="/assets/images/KheloyarnetLogo.svg"
                      width={isMobile ? 150 : 200}
                      alt="Kheloyarnet Logo"
                      className="logo-img"
                    />
                  </div>

                  {/* WhatsApp Section */}
                  <div className="text-center mb-3 whatsapp-img-container text-centers">
                    <img
                      src="https://dabba.b-cdn.net/images/whatsapp-mobile.svg"
                      style={{ width: isMobile ? "200px" : "300px" }}
                      alt="WhatsApp Mobile"
                      className="whatsapp-img"
                    />
                  </div>

                  {/* Login Form */}
                  <div className="mb-3 text-center form-heading text-centers">
                    <h3 style={{ fontFamily: "sans-serif" }}>Self Registration</h3>
                    <p style={{ fontFamily: "sans-serif" }}>
                      Please fill in this form to create an account
                    </p>
                  </div>

                  <Form onSubmit={submitregister}>
                    {/* Username */}
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Username"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        className="text-light py-2 border-secondary rounded-2 borderss"
                        aria-label="Username"
                      />
                    </Form.Group>

                    {/* Phone with Country Code */}
                    <InputGroup className="mb-3">
                      <div className="d-flex w-100">
                        <InputGroup.Text
                          className="bg-black text-light border-secondary d-flex align-items-center justify-content-center phone-eyes"
                        >
                          <img
                            src="/assets/images/india_flag-2016.jpg"
                            alt="Indian Flag"
                            className="me-1"
                            style={{ width: "20px", height: "14px" }}
                          />
                          <span className="me-1">+91</span>
                          <span>▼</span>
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleInputChange}
                          className="bg-black text-light py-2 border-secondary phone-input-box"
                          aria-label="Phone Number"
                        />
                      </div>
                    </InputGroup>

                    {/* Password */}
                    <InputGroup className="mb-3">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        name="cpassword"
                        value={formData.cpassword}
                        onChange={handleInputChange}
                        className="text-light py-2  password-input-box"
                        aria-label="Password"
                      />
                      <InputGroup.Text
                        className="bg-black text-light border-secondary password-eye"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                      </InputGroup.Text>
                    </InputGroup>

                    {/* Confirm Password */}
                    <InputGroup className="mb-4">
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        name="pwd"
                        value={formData.pwd}
                        onChange={handleInputChange}
                        className="bg-black text-light py-2 border-secondary password-input-box"
                        aria-label="Confirm Password"
                      />
                      <InputGroup.Text
                        className="bg-black text-light border-secondary password-eye"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                      </InputGroup.Text>
                    </InputGroup>

                    {/* Checkboxes */}
                    <div className="mb-4">
                      <div className="d-flex align-items-center mb-3">
                        <input
                          className="form-check-input shadow-none border-0 me-2 font-size-labelss"
                          type="checkbox"
                          name="imOver18"
                          checked={formData.imOver18}
                          onChange={handleInputChange}
                          id="imover18"
                        />
                        <span className="checkbox-label font-size-labelss" style={{ marginLeft: "33px" }}>
                          I'm over 18
                        </span>
                      </div>

                      <div className="d-flex align-items-center">
                        <input
                          className="form-check-input shadow-none border-0 me-2  font-size-labelss checked:bg-yellow-500"
                          type="checkbox"
                          name="iAcceptAll"
                          checked={formData.iAcceptAll}
                          onChange={handleInputChange}
                          id="iaccept"
                        
                        />
                        <span className="checkbox-label font-size-labelss " style={{ marginLeft: "33px" }}>
                          I accept all the{" "}
                          <a
                            href="#"
                            className="text-warning text-decoration-none font-size-labelss"
                          >
                            Terms & Conditions
                          </a>
                        </span>
                      </div>
                    </div>

                    {/* Register Button */}
                    <Button
                      variant="warning"
                      type="submit"
                      
                      className="w-100 py-2 text-dark fw-bold mb-3"
                      style={{ backgroundColor: "#8B6900" , height:"50px", fontSize:"20px" }}
                    >
                      Register
                    </Button>
                    <div className="d-flex align-items-center">
                        
                        <span className="checkbox-label font-size-labelss " onClick={() => setactive(true)} style={{ marginLeft: "33px" }}>
                          Already have an account ?{" "}
                          <a
                            href="#"
                            className="text-warning text-decoration-none font-size-labelss"
                          >
                            Login
                          </a>
                        </span>
                      </div>
                  </Form>
                </div>
              </Container>

              {/* WhatsApp Button (Fixed Position) */}
              <div className="whatsapp-button">
                <Button className="bg-success text-white rounded-pill d-flex align-items-center py-2 px-3">
                  <span className="me-2">Get an ID on WhatsApp</span>
                  <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
        <app-sitefooter
              _ngcontent-mkq-c100=""
              className="ng-tns-c100-1"
              _nghost-mkq-c94=""

            >
              <div
                _ngcontent-mkq-c94=""
                id="site_footer-settings"
                className="site_footer "
                style={{ display: "block" }}
              >
                <div _ngcontent-mkq-c94=""  style={{backgroundColor:"grey"}} className="site_footer_inn">
                  <ul _ngcontent-mkq-c94="" className="nav-bottom-site site-ui-inn">
                    <li _ngcontent-mkq-c94="" className="active">
                      <Link
                        _ngcontent-mkq-c94=""
                        to="/"
                      >
                        <img
                          src="/assets/images/27500.png"
                          alt=""
                          _ngcontent-mkq-c94=""
                          className="sport new_home_icon new_home_icon_yellow  home-button"
                        />
                        {/* <span _ngcontent-mkq-c94="" className="name-style">
                          Home
                        </span> */}
                      </Link>
                    </li>
                    {/* <li _ngcontent-mkq-c94="">
                      <Link
                        to="/live-casino"
                        _ngcontent-mkq-c94=""
                        routerlink="/casinos/get/all"
                      >
                        <img
                          src="/assets/images/9383.png"
                          _ngcontent-mkq-c94=""
                          className="casino new_casino_icon new_casino_yellow"
                          alt=""
                        />
                        <span _ngcontent-mkq-c94="" className="name-style">
                          Casinos
                        </span>
                      </Link>
                    </li> */}
                    
      
                   <div style={{ marginRight:"10px"}} className="d-flex ml-1 gap-3">
                   <li
                      _ngcontent-mkq-c94=""
                      // routerlink="/sports"
                      className="hide-specific ng-star-inserted "
                      tabIndex={0}
                      onClick={handleFooterLink}
                    >
                      <Link _ngcontent-mkq-c94="" className="list-icon-bg">
                        <img
                          src="https://daba.b-cdn.net/bet365exch.in/B.svg"
                          alt=""
                          _ngcontent-mkq-c94=""
                          className="liveCasinoss"
                        />
                        
                      </Link>
                    </li>
      
                    <li _ngcontent-mkq-c94="">
                      <Link _ngcontent-mkq-c94="" to='/menu'>
                        <img
                          _ngcontent-mkq-c94=""
                          className="icon-navbar-site"
                          style={{ maxWidth: "18px" , }}
                          alt="icon_Kheloyaar360"
                          src="https://dabba.b-cdn.net/global/menuglobal.svg"
                        />
                       
                      </Link>
                    </li>
                   </div>
                  </ul>
                </div>
              </div>
            </app-sitefooter>
    </>
  );
};

export default RegisterForm;